import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import LoadingConstants from 'app/shared/constants/LoadingConstants';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import TableMFH from 'app/shared/components/TableMFH';

import UserManagementActions from 'app/shared/actions/UserManagementActions';
import { UserManagementSelectors } from 'app/shared/selectors';

const columnConfig = [
    {
        width: 5,
        dataKey: 'name',
        header: 'Property',
        isSortable: true,
        renderer: property => property.name || property.street,
    },
    {
        width: 4,
        dataKey: 'city',
        header: 'City',
        renderer: property => property.city,
    },
    {
        width: 2,
        dataKey: 'state',
        header: 'State',
        renderer: property => property.state,
    },
];

const propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
};

const PropertyPicker = ({
    dispatch,
    onNextStep,
    onCancel,
    onBack,
    currentUser,
    isInvitation,
}) => {
    const mapCurrentProperties = () => {
        const indexes = new Set();
        const propertySet = new Set(currentUser.properties.map(property => property.listingId));
        currentUser.availableProperties.forEach((property, i) => {
            if (propertySet.has(property.listingId)) {
                indexes.add(i);
            }
        });
        return indexes;
    };
    const selectedIndexes = mapCurrentProperties();

    React.useEffect(() => {
        if (isInvitation) {
            dispatch(UserManagementActions.getInitialUserListings());
        }
    }, []);

    const handleUpdateProperties = (propertyIndexes) => {
        const newProperties = [];
        for (const index of propertyIndexes) {
            newProperties.push(currentUser.availableProperties[index]);
        }
        dispatch(UserManagementActions.currentUserSetProperties(newProperties));
    };

    const renderTableHeader = () => (
        <Row className="PropertyPicker-top-banner">
            <Col>
                <Text type="h4" emphasize={true}>
                    {selectedIndexes.size
                        ? `${selectedIndexes.size} ${selectedIndexes.size > 1 ? 'properties' : 'property'}`
                        : 'Select properties'}
                </Text>
            </Col>
        </Row>
    );

    const isLoading = currentUser.propertiesLoadingState !== LoadingConstants.SUCCESS;

    return (
        <div className="PropertyPicker">
            <div className="PropertyPicker-container">
                <StyledContainer borderLeft={true} borderRight={true} borderTop={true}>
                    {isLoading ? <SpinnerContainer /> : (
                        <TableMFH
                            columnConfig={columnConfig}
                            data={currentUser.availableProperties}
                            idKey="zrnNumber"
                            selected={selectedIndexes}
                            onSelectRow={handleUpdateProperties}
                            TopBannerComponent={renderTableHeader}
                            rowSelectionDisabled={rowData => rowData.contactEmail === currentUser.email}
                        />
                    )}
                </StyledContainer>
            </div>
            <div className="Questions-footer">
                <Link className="Questions-button" onClick={onCancel}>
                    Cancel
                </Link>
                <div>
                    <Link className="Questions-button" onClick={onBack}>
                        Back
                    </Link>
                    <Button type="primary" onClick={onNextStep} disabled={!currentUser.properties.length}>
                        Continue
                    </Button>
                </div>
            </div>
        </div>
    );
};


PropertyPicker.propTypes = propTypes;

const mapStateToProps = state => ({
    currentUser: UserManagementSelectors.makeCurrentUser(state),
});

export default connect(mapStateToProps)(PropertyPicker);
